import Image from 'next/image';

import { KeyValueRow, KeyValueTable, Text } from '@/design-system/components/ui';

import { Trigger } from '../../domain';
import { AddressChip } from './components/AddressChip';

interface Props {
  trigger: Trigger;
}

export const AquariusSwapsTriggerFullDetails = ({ trigger }: Props) => {
  const poolAddress = trigger.context?.pool_address ?? '';

  const executedWhenDisplay = (
    <div className="tw:flex tw:flex-row tw:gap-2 tw:items-center tw:flex-wrap">
      <Text as="span" variant="body-sm" color="muted">
        User swaps in Aquarius pool
      </Text>
      {poolAddress ? (
        <AddressChip
          address={poolAddress}
          scannerUrl={`https://stellar.expert/explorer/public/contract/${poolAddress}`}
          hideChainIcon
        />
      ) : null}
    </div>
  );

  const networkDisplay = (
    <div className="tw:flex tw:flex-row tw:items-center tw:gap-2">
      <Image src="/assets/webp/stellar.webp" alt="Stellar" width={20} height={20} />
      <span>Stellar</span>
    </div>
  );

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Executed when" value={executedWhenDisplay} />
      <KeyValueRow label="Network" value={networkDisplay} />
      <KeyValueRow label="Volume Expression" value={trigger.volumeExpression ?? '-'} />
      <KeyValueRow label="Revenue Expression" value={trigger.revenueExpression ?? '-'} />
      <KeyValueRow label="Volume Currency" value={trigger.currencyVolumeExpression ?? '-'} />
      <KeyValueRow label="Revenue Currency" value={trigger.currencyRevenueExpression ?? '-'} />
      <KeyValueRow label="Argument conditions" value={trigger.conditionExpression ?? '-'} />
    </KeyValueTable>
  );
};
